export const MESSAGE: string = 'forbidden';
 
export default class ForbiddenException extends Error {
  constructor() {
    super();
    this.message = MESSAGE;
  }
}
 
export function isForbidden(error: any): boolean {
  return (error.message === MESSAGE);
}